<script setup lang="ts">
const { t } = useLocale();

defineProps<{
  type: 'residential' | 'mobile' | 'corporate'
  list: { value: string, needToTranslate: boolean }[]
  needToTranslate?: boolean
}>();
</script>

<template>
  <div class="sx-advantages-list" :class="[type]">
    <div v-for="advantage in list" class="sx-advantages-list__item">
      <div class="sx-advantages-list__item-point" />
      <span class="sx-advantages-list__item-text">
        {{ advantage.needToTranslate ? t(advantage.value) : advantage.value}}
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.sx-advantages-list {
  display: grid;
  grid-template-columns: max-content max-content;

  &.mobile {
    justify-content: space-between;
  }

  @media (width < 700px) {
    grid-template-columns: max-content;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__item-text {
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    @media (max-width: 600px) {
      font-size: 16px;
    }
  }

  &__item-point {
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }

  &.residential &__item-point {
    background: -webkit-linear-gradient(#e89ce6, #f8c5d7);
  }
  &.mobile &__item-point {
    background: -webkit-linear-gradient(#cee6f8, #49adff);
  }
  &.corporate &__item-point {
    background: -webkit-linear-gradient(#e89ce6, #f8c5d7);
  }
}
</style>
